/* ==========================================================================
   Sedgars Jewellery boutique — behaviour
   Loaded only on templates whose suffix contains 'boutique'.

   Two components: the bespoke journey stepper and the ring builder preview.
   There is deliberately no router here. Every boutique destination is a real
   Shopify URL with its own template (spec sec.5), so navigation is the
   browser's job.

   Both components are progressive enhancements. The journey renders every
   step as readable content without JS; the ring builder is a set of real
   radio inputs inside a real form, so a configuration still submits
   correctly if this file never executes.
   ========================================================================== */

(function () {
  'use strict';

  /* ------------------------------------------------ bespoke journey ------ */

  /**
   * Tablist stepper. The markup carries all seven panels; this wires the
   * roving-tabindex keyboard pattern and panel visibility on top.
   */
  function initJourney(root) {
    var tabs = Array.prototype.slice.call(
      root.querySelectorAll('[role="tab"]')
    );
    var panels = Array.prototype.slice.call(
      root.querySelectorAll('[role="tabpanel"]')
    );

    if (!tabs.length || !panels.length) return;

    function select(index, focus) {
      tabs.forEach(function (tab, i) {
        var selected = i === index;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.setAttribute('tabindex', selected ? '0' : '-1');
      });

      panels.forEach(function (panel, i) {
        panel.hidden = i !== index;
      });

      if (focus) tabs[index].focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        select(i, false);
      });

      tab.addEventListener('keydown', function (event) {
        var last = tabs.length - 1;
        var next = null;

        switch (event.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            next = i === last ? 0 : i + 1;
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            next = i === 0 ? last : i - 1;
            break;
          case 'Home':
            next = 0;
            break;
          case 'End':
            next = last;
            break;
          default:
            return;
        }

        event.preventDefault();
        select(next, true);
      });
    });

    // Trust the markup's initial state rather than forcing step one, so a
    // section configured to open on a different step is honoured.
    var initial = tabs.findIndex(function (tab) {
      return tab.getAttribute('aria-selected') === 'true';
    });
    select(initial === -1 ? 0 : initial, false);
  }

  /* --------------------------------------------------- ring builder ------ */

  /**
   * Live preview for the ring configurator.
   *
   * No price is computed or displayed. The prototype's "Estimated from
   * R 24 500" is deliberately absent: published indicative pricing on bespoke
   * work anchors the customer before consultation and is hard to move off
   * (spec sec.9). The panel shows the configuration instead.
   */
  function initBuilder(root) {
    var band = root.querySelector('[data-bq-band]');
    var gem = root.querySelector('[data-bq-gem]');
    var summary = root.querySelector('[data-bq-summary]');
    var stepOut = root.querySelector('[data-bq-step]');
    var groups = Array.prototype.slice.call(
      root.querySelectorAll('[data-bq-group]')
    );

    if (!groups.length) return;

    // Which group the visitor is on. Initialised to 1 rather than left to
    // the first interaction, so the counter is never stale on load.
    var currentStep = 1;

    function checked(group) {
      return group.querySelector('input:checked');
    }

    function render() {
      var parts = [];

      groups.forEach(function (group) {
        var input = checked(group);
        if (!input) return;

        var kind = group.getAttribute('data-bq-group');
        var label = input.getAttribute('data-bq-label') || '';

        if (kind === 'metal' && band) {
          band.style.borderColor = input.getAttribute('data-bq-colour') || '';
        }

        if (kind === 'stone' && gem) {
          gem.style.background = input.getAttribute('data-bq-colour') || '';
        }

        if (kind === 'shape' && gem) {
          // The input's value carries the human-readable label, because it
          // is what lands in the enquiry email. The CSS modifier is a
          // separate attribute.
          gem.className =
            'bq-gem bq-gem--' + (input.getAttribute('data-bq-shape') || 'round');
        }

        if (label) parts.push(label);
      });

      if (summary) summary.textContent = parts.join(' · ');
      if (stepOut) stepOut.textContent = String(currentStep);
    }

    groups.forEach(function (group, index) {
      group.addEventListener('change', function (event) {
        if (!event.target.matches('input')) return;
        currentStep = index + 1;
        render();
      });
    });

    render();
  }

  /* ----------------------------------------------------------- boot ------ */

  function boot() {
    document.querySelectorAll('[data-bq-journey]').forEach(initJourney);
    document.querySelectorAll('[data-bq-builder]').forEach(initBuilder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // The theme editor tears down and re-renders a section on every change;
  // re-initialise whichever section was just rebuilt.
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    section.querySelectorAll('[data-bq-journey]').forEach(initJourney);
    section.querySelectorAll('[data-bq-builder]').forEach(initBuilder);
  });
})();
